import axios from 'axios';
import { stringify } from 'qs';
import CookieService from 'services/cookie';

const client = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  paramsSerializer: {
    serialize: params => stringify(params),
  },
  withCredentials: true,
  headers: {
    common: {
      Authorization: `Bearer ${CookieService.get('authApiToken')}`,
    },
  },
});

export const get = client.get;
export const post = client.post;

export const setAuth = (auth: string | null) => {
  if (!auth) {
    delete client.defaults.headers.Authorization;
    return;
  }

  client.defaults.headers.Authorization = `Bearer ${auth}`;
};

export default {
  get,
  post,
  setAuth,
};
